import script from "./select-input.vue?vue&type=script&setup=true&lang=js"
export * from "./select-input.vue?vue&type=script&setup=true&lang=js"

import "./select-input.vue?vue&type=style&index=0&id=d6216416&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6216416"]])

export default __exports__